import { getDate } from "../../Interfaces/CustomDateTime";
export const getCurrentMonthDate = (mediumPartnerProgram) => {
    const periodStartedAt = mediumPartnerProgram.payload.currentMonthAmount.periodStartedAt;
    return getDate(periodStartedAt);
};
